import { InMemoryDocumentLoader } from './in-memory-document-loader.js';
import { CalmHubDocumentLoader } from './calmhub-document-loader.js';
import { DirectUrlDocumentLoader } from './direct-url-document-loader.js';
import { MultiStrategyDocumentLoader } from './multi-strategy-document-loader.js';
/**
 * Browser counterpart of `buildDocumentLoader`: no filesystem strategies, no `process.cwd()`.
 * Order of precedence: in-memory documents, then CALM Hub (if configured), then direct URLs.
 */
export function buildBrowserDocumentLoader(opts) {
    const debug = opts.debug ?? false;
    const loaders = [new InMemoryDocumentLoader(opts.documents, debug)];
    if (opts.calmHubUrl) {
        loaders.push(new CalmHubDocumentLoader(opts.calmHubUrl, debug, opts.authPlugin));
    }
    if (opts.allowRemote !== false) {
        loaders.push(new DirectUrlDocumentLoader(debug, undefined, opts.allowedRemoteHosts));
    }
    return new MultiStrategyDocumentLoader(loaders, debug);
}
//# sourceMappingURL=browser-document-loader.js.map